import React from 'react';

function AvailableIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" fill="none" viewBox="0 0 24 20">
      <rect width="24" height="20" fill="#000" rx="2" />
      <path
        fill="#fff"
        d="M17 10c0-2.742-2.258-5-5-5-2.762 0-5 2.258-5 5a5 5 0 005 5c2.742 0 5-2.238 5-5zm-5.585 2.661a.342.342 0 01-.463 0l-2.097-2.096a.342.342 0 010-.464l.464-.444a.285.285 0 01.443 0l1.431 1.412 3.025-3.025a.285.285 0 01.443 0l.464.444a.342.342 0 010 .464l-3.71 3.71z"
      />
    </svg>
  );
}

export default AvailableIcon;
